import { render, staticRenderFns } from "./AddNewPaymentForm.vue?vue&type=template&id=66d52d50&scoped=true"
import script from "./AddNewPaymentForm.vue?vue&type=script&lang=js"
export * from "./AddNewPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./AddNewPaymentForm.vue?vue&type=style&index=0&id=66d52d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d52d50",
  null
  
)

export default component.exports